import { MdOutlinePriceChange } from "react-icons/md";

const ChargeIcon = () => {
  return <MdOutlinePriceChange size={25} className="sidebar-icon" />;
};

export default ChargeIcon;
